module.exports = __webpack_public_path__ + "static/media/penneli-2.f9e58499.png";